import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

export default function Confirmation({ onForm, close, sending }) {
  useEffect(() => {
    if (sending) {
      onForm();
      close();
    }
  }, [sending]);

  return <p>Confirma transformar o vazamento utilizando estes dados?</p>;
}

Confirmation.propTypes = {
  onForm: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
};
